import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from './Button';
import Modal from './Modal';

interface LogoutModalProps {
  isOpen: boolean;
  onLogout: () => void;
  onCancel: () => void;
}

export const LogoutModal: React.FC<LogoutModalProps> = React.memo(({ 
  isOpen,
  onLogout, 
  onCancel 
}) => {
  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onCancel}
      title="Confirm Logout"
      maxWidth="450px"
    >
      <div className="p-5">
        <div className="flex items-center mb-4">
          <div className="p-2 rounded-full bg-red-500/10 mr-3">
            <AlertTriangle className="w-5 h-5 text-red-500" />
          </div>
          <p className="text-base text-text-secondary-light dark:text-text-secondary-dark">
            Are you sure you want to log out of your account? You will need to log in again to access your dashboard.
          </p>
        </div>

        <div className="mt-6 flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
          <Button 
            variant="outline" 
            onClick={onCancel}
            className="w-full sm:w-auto"
          >
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={onLogout}
            className="w-full sm:w-auto !bg-red-500 hover:!bg-red-600 !border-red-500 !shadow-red-500/30"
          >
            Yes, Logout
          </Button>
        </div>
      </div>
    </Modal>
  );
});

LogoutModal.displayName = 'LogoutModal';

export default LogoutModal; 